import { render, staticRenderFns } from "./EditProductCharacteristics.vue?vue&type=template&id=3db9d7e6&scoped=true&"
import script from "./EditProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./EditProductCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./EditProductCharacteristics.vue?vue&type=style&index=0&id=3db9d7e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db9d7e6",
  null
  
)

export default component.exports